'use server'

import { after } from 'next/server'
import { normalizeInvitationEmail } from '@/lib/invitations'
import { hasInvitationMailer, panelRequestContext } from '@/lib/invitations-mail'
import {
  PASSWORD_RESET_EMAIL_LIMIT,
  consumePasswordResetLimits,
  findPanelMemberByEmail,
  requestClientIp,
  sendPasswordResetMail,
} from '@/lib/password-reset'

export async function requestPasswordReset(
  rawEmail: string,
): Promise<{ success: true; message: string } | { success: false; error: string }> {
  let email: string
  try { email = normalizeInvitationEmail(rawEmail) } catch { return { success: false, error: 'Geçerli bir e-posta adresi girin.' } }
  if (!hasInvitationMailer()) {
    return { success: false, error: 'Şifre sıfırlama e-postası şu anda gönderilemiyor. Panel yöneticinizle iletişime geçin.' }
  }
  let context: { url: string; tenantId: string | null }
  try { context = await panelRequestContext('/') } catch { return { success: false, error: 'Panel adresi doğrulanamadı.' } }

  const limitError = await consumePasswordResetLimits([
    { bucket: 'admin:password-reset-ip', identity: await requestClientIp(), limit: 10, windowSeconds: 900 },
    { ...PASSWORD_RESET_EMAIL_LIMIT, identity: email },
  ])
  if (limitError) return { success: false, error: limitError }

  // Hesap araması ve gönderim yanıttan sonra yapılır: yanıtın içeriği de süresi
  // de adresin bu panelde kayıtlı olup olmadığını ele vermez.
  after(async () => {
    try {
      const user = await findPanelMemberByEmail(context.tenantId, email)
      if (user) await sendPasswordResetMail(user, context.url)
    } catch {
      console.error('[password-reset] sıfırlama e-postası gönderilemedi')
    }
  })
  return {
    success: true,
    message: 'Bu e-posta adresi bu panelde kayıtlıysa şifre sıfırlama bağlantısı gönderildi. Gelen kutunuzu ve spam klasörünüzü kontrol edin.',
  }
}
